import React, { useEffect, useState } from "react";
import contact from "../assets/images/contact-img.png";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useSelector } from "react-redux";

const ContactUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const locationData = useSelector((state) => state.location.locationData);

  const [values, setValues] = useState({
    full_name: "",
    email: "",
    phone: "",
    countryCode: "",
    message: "",
  });
  const [settingList, setSettingList] = useState({
    address: "",
    contact: "",
    email: "",
    social_links_1: "",
  });
  const fetchSettingList = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/settings`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem("token")}`,
        },
      });
      // console.log("res", res)
      const data = await res.json();
      setSettingList(data.responseObject);
    } catch (error) {
      // console.log("error fetch faq", error);
    }
  };

  useEffect(() => {
    fetchSettingList();
  }, []);
  const customId = "custom-id-yes";

  // Add validation patterns
  const validationPatterns = {
    full_name: /^[a-zA-Z\s]{2,50}$/,
    email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    phone: /^[0-9]{10}$/,
    message: /^[\s\S]{10,500}$/, // Allow any characters, min 10, max 500
  };

  // Add error state
  const [errors, setErrors] = useState({
    full_name: false,
    email: false,
    phone: false,
    message: false,
  });

  const validateField = (name, value) => {
    if (!validationPatterns[name]) return true;
    return validationPatterns[name].test(value);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const isValid = validateField(name, value);
    
    setErrors(prev => ({
      ...prev,
      [name]: !isValid
    }));

    setValues(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const navigate = useNavigate();
  const validateContact = () => {
    const { full_name, email, message } = values;
    const toastId = "contact-form";
    if (!full_name?.trim()) {
      if (!toast.isActive(toast)) {
        toast.error("Please Enter Your Name", { toastId: toastId });
      }
      return false;
    }
    if (!email?.trim()) {
      toast.error("Please Enter Your Email", { toastId: toastId });
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      if (!toast.isActive(toast)) {
        toast.error("Please Enter Valid Email Address", { toastId: toastId });
      }
      return false;
    }
    if (!message?.trim()) {
      if (!toast.isActive(toast)) {
        toast.error("Please Enter Your Message", { toastId: toastId });
      }
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateContact()) {
      // console.log("Form data:", values);
      try {
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/help`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify(values),
        });
        // console.log(res)
        const data = await res.json();
        if (data.success) {
          toast.success(data.message);
          navigate("/");
        } else {
          toast.error(data.message);
        }
      } catch (error) {
        // console.log("error help form", error);
      }
    }
  };
  return (
    <>
      <section className="contact-sec tp-space mt-150">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-12">
              <div className="contact-innr">
                <h2>Do you need support? Our team is ready to help</h2>
                <p>
                  We are passionate about building carefully thought out
                  products that will improve your design workflow.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="contact-frm tp-space pt-0">
        <div className="container">
          <div className="contact-frm-innr">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <img src={contact} alt="contact" />
              </div>
              <div className="col-lg-6">
                <div className="contact-frm-rgt">
                  <form action="" onSubmit={handleSubmit}>
                    <div className="custom-frm-bx mt-3">
                      <label>Full Name*</label>
                      <input
                        type="text"
                        name="full_name"
                        value={values.full_name}
                        onChange={handleChange}
                        className={`form-control ${errors.full_name ? 'is-invalid' : ''}`}
                        placeholder="Enter your full name"
                        maxLength={50}
                      />
                      {errors.full_name && (
                        <div className="invalid-feedback">
                          Please enter a valid name (2-50 characters, letters only)
                        </div>
                      )}
                    </div>
                    <div className="custom-frm-bx">
                      <label>Email Address*</label>
                      <input
                        type="email"
                        name="email"
                        value={values.email}
                        onChange={handleChange}
                        className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                        placeholder="Enter your email address"
                        maxLength={50}
                      />
                      {errors.email && (
                        <div className="invalid-feedback">
                          Please enter a valid email address
                        </div>
                      )}
                    </div>
                    <div className="custom-frm-bx">
                      <label>Phone*</label>
                      <div className="custom-frm-bx-innr" style={{border: "1px solid #dee2e6", borderRadius: "5px"}}>
                      <PhoneInput
                        country={(locationData?.countryCode || "us").toLowerCase()}
                        value={String(values.phone || '')}
                        onChange={(phone, data) => {
                          setValues(prev => ({
                            ...prev,
                            phone: String(phone),
                            countryCode: data.dialCode
                          }));
                          
                          // Validate phone number
                          const isValid = validateField('phone', String(phone).slice(data.dialCode.length));
                          setErrors(prev => ({
                            ...prev,
                            phone: !isValid
                          }));
                        }}
                        inputClass={`form-control ${errors.phone ? 'is-invalid' : ''}`}
                        containerClass="phone-input-container"
                      />
                      </div>
                      {errors.phone && (
                        <div className="invalid-feedback">
                          Please enter a valid 10-digit phone number
                        </div>
                      )}
                    </div>
                    <div className="custom-frm-bx">
                      <label>Message*</label>
                      <textarea
                        name="message"
                        value={values.message}
                        onChange={handleChange}
                        className={`form-control ${errors.message ? 'is-invalid' : ''}`}
                        placeholder="Enter your message (minimum 10 characters)"
                        maxLength={500}
                      />
                      {errors.message && (
                        <div className="invalid-feedback">
                          Please enter a message (10-500 characters)
                        </div>
                      )}
                    </div>
                    <div className="custom-frm-bx">
                      <button 
                        className="thm-btn dark p-3 w-100" 
                        type="submit"
                        disabled={Object.values(errors).some(error => error)}
                      >
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div className="row justify-content-center contact-cards-container">
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="contact-card h-100 d-flex flex-column justify-content-center align-items-center text-center">
                <span className="fa fa-map-marker-alt" />
                <h6>Address</h6>
                <a href="javascript:void(0);">{settingList.address}</a>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="contact-card h-100 d-flex flex-column justify-content-center align-items-center text-center">
                <span className="fas fa-phone" />
                <h6>Call us anytime</h6>
                <Link to={`tel:${settingList.contact}`}>
                  +91 {settingList.contact}
                </Link>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="contact-card h-100 d-flex flex-column justify-content-center align-items-center text-center">
                <span className="far fa-envelope-open" />
                <h6>Send Mail</h6>
                <Link to={`mailto:${settingList.email}`}>{settingList.email}</Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactUs;
